import { Button } from "@/components/ui/button";
import { copyToClipboard } from "@/utils/copy-to-clipboard";
import { AxiosError } from "axios";
import { Link, useRouteError } from "react-router-dom";

export function PageErrorBoundary() {
  //TODO: Log error to Sentry
  const error = useRouteError();

  const getErrorMessage = (error: unknown) => {
    if (error instanceof AxiosError && error.response?.data?.context)
      return error.response?.data?.context.context;

    if (error instanceof AxiosError && error.response?.data?.message)
      return error.response?.data?.message;

    if (error instanceof AxiosError && error.response?.data?.error)
      return error.response?.data?.error;

    if (error instanceof Error) return error.message;
    return "An error occurred";
  };

  const renderError = (error: unknown) => {
    if (error instanceof AxiosError)
      return JSON.stringify(error.response, null, 2);
    return JSON.stringify(error, null, 2);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-full w-[800px]">
        <h1 className="text-2xl font-bold text-red-600 mb-4">
          Oops! Something went wrong.
        </h1>
        <p className="text-gray-600 mb-4">{getErrorMessage(error)}</p>
        <pre className="text-sm text-gray-600 mb-4 break-words overflow-x-auto w-full h-40">
          {renderError(error)}
        </pre>
        <div className="flex justify-end gap-4">
          <Link to="/">
            <Button>Voltar para a home</Button>
          </Link>
          <Button
            variant="outline"
            onClick={() => copyToClipboard(JSON.stringify(error, null, 2))}
          >
            Copiar erro
          </Button>
        </div>
      </div>
    </div>
  );
}
